import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { Card, CircularProgress, Grid } from "@mui/material";
import '../categoriesView/categoryesView.css';
import { ProductHandler } from "../../../classes/methods/productMethods/productMethods";
import { Product } from "../../../classes/types/product/product";

interface props {}

interface state {
  unicoProducts: Array<Product>;
  loading: boolean;
}

class UnicoProductsView extends Component<props, state> {
  constructor(props: props) {
    super(props);

    this.state = {
      loading: true,
      unicoProducts: [],
    };
  }

  componentDidMount() {
    this.refreshData();
  }

  refreshData = () => {
    this.setState({ loading: true });
    ProductHandler.GetUnicoProducts()
      .then((newUnicoProducts) => {
        newUnicoProducts.sort((a, b) => a.name.localeCompare(b.name));
        this.setState({
          unicoProducts: newUnicoProducts,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  render() {
    if (this.state.loading) return <CircularProgress />;

    return (
      <div>
        <span className={'caregory-view-title'}>SISTEMI UNICO</span>
        {this.state.unicoProducts.length > 0 ? (
          <Grid
            alignContent={'flex-start'}
            direction="row"
            className={'caregory-view-container'}
            justifyContent="center"
            container
          >
            {this.state.unicoProducts.map((unicoPro, index) => (
              <Link
                key={'category' + index}
                to={'/shop/home/prodotto/' + unicoPro.id}
                style={{ margin: '1%' }}
              >
                <Card
                  style={{
                    backgroundImage:
                      unicoPro.images && unicoPro.images.length > 0
                        ? `url(${unicoPro.images[0].link})`
                        : "",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                  }}
                  className={'caregory-card'}
                >
                  <div className={'caregory-card-text-container'}>
                    <span className={'caregory-card-text'}>{unicoPro.name}</span><br/>
                  </div>
                </Card>
              </Link>
            ))}
          </Grid>
        ) : (
          <Grid
            alignContent={'flex-start'}
            direction="row"
            className={'caregory-view-container'}
            justifyContent="center"
            container
          >
            <div className={'caregory-card-text-container'}>
              <span style={{ color: 'darkgrey' }} className={'caregory-card-text'}>
                Nessuna Prodotto Unico
              </span>
              <br/>
            </div>
          </Grid>
        )}
      </div>
    );
  }
}

export default UnicoProductsView;
